import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private snackBar: MatSnackBar,
    private localeService: LocaleService,
  ) {}

  openToast(message: string, action: string | undefined = undefined, config?: MatSnackBarConfig<TextOnlySnackBar>): MatSnackBarRef<TextOnlySnackBar> {
    config = { duration: 4000, horizontalPosition: 'center', verticalPosition: 'top', ...config }
    message = this.localeService.getString(message);
    return this.snackBar.open(message, action, config);
  }

  openErrorToast(message: string, action: string | undefined = undefined, config?: MatSnackBarConfig<TextOnlySnackBar>): MatSnackBarRef<TextOnlySnackBar> {
    config = { ...config, panelClass: ['toast', 'error', 'mat-error'], duration: 7000 }
    return this.openToast(message, action, config);
  }

  openSuccessToast(message: string, action: string | undefined = undefined, config?: MatSnackBarConfig<TextOnlySnackBar>): MatSnackBarRef<TextOnlySnackBar> {
    config = { ...config, panelClass: ['toast', 'success', 'mat-primary'] }
    return this.openToast(message, action, config);
  }

  openInfoToast(message: string, action: string | undefined = undefined, config?: MatSnackBarConfig<TextOnlySnackBar>): MatSnackBarRef<TextOnlySnackBar> {
    config = { ...config, panelClass: ['toast', 'info'] }
    return this.openToast(message, action, config);
  }

  dismissToast(): void {
    this.snackBar.dismiss();
  }
}
